<template>
	<div id="mobile_clients_filter" ref="mobile_clients_filter" class="offcanvas offcanvas-right" v-click-outside="handleOutsideClick">
		<button id="mobile_clients_filter_toggle" style="display: none;"></button>
		<!--begin::Header-->
		<div class="offcanvas-header d-flex align-items-center justify-content-between pb-5">
			<h4 class="font-weight-bold m-0">
				{{ $t("mobileClientsFilter.title") }}
			</h4>
			<a href="#" class="" id="mobile_clients_filter_close" @click="closeOffcanvas('mobile_clients_filter')">
				<i class="ki ki-close icon-md"></i>
			</a>
		</div>
		<!--end::Header-->
		<!--begin::Content-->
		<perfect-scrollbar class="offcanvas-content mr-n5 scroll" style="max-height: 85vh; position: relative;">
			<div class="clients-filters-container">
				<!-- Physical entities option -->
				<div class="client-filter-item" @click="updateFilter('physicalEntities')">
					<div class="filter-description">
						<div class="filter-icon">
							<span class="svg-icon svg-icon-dark svg-icon-2x">
								<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
									<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<polygon points="0 0 24 0 24 24 0 24" />
										<path d="M18,14 C16.3431458,14 15,12.6568542 15,11 C15,9.34314575 16.3431458,8 18,8 C19.6568542,8 21,9.34314575 21,11 C21,12.6568542 19.6568542,14 18,14 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
										<path d="M17.6011961,15.0006174 C21.0077043,15.0378534 23.7891749,16.7601418 23.9984937,20.4 C24.0069246,20.5466056 23.9984937,21 23.4559499,21 L19.6,21 C19.6,18.7490654 18.8562935,16.6718327 17.6011961,15.0006174 Z M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
									</g>
								</svg>
							</span>
						</div>
						<span class="filter-name">{{ $t("mobileClientsFilter.physicalEntities") }}</span>
					</div>
					<div class="filter-selected" v-show="currentFilter === 'physicalEntities'">
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
							<polyline points="20 6 9 17 4 12"></polyline>
						</svg>
					</div>
				</div>
				<!-- Legal entities option -->
				<div class="client-filter-item" @click="updateFilter('legalEntities')">
					<div class="filter-description">
						<div class="filter-icon">
							<span class="svg-icon svg-icon-dark svg-icon-2x">
								<!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo7/dist/../src/media/svg/icons/Clothes/Briefcase.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
									<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
										<rect x="0" y="0" width="24" height="24" />
										<path d="M5.84026576,8 L18.1597342,8 C19.1999115,8 20.0664437,8.79732479 20.1528258,9.83390904 L20.8194924,17.833909 C20.9112219,18.9346631 20.0932459,19.901362 18.9924919,19.9930915 C18.9372479,19.9976952 18.8818364,20 18.8264009,20 L5.1735991,20 C4.0690296,20 3.1735991,19.1045695 3.1735991,18 C3.1735991,17.9445645 3.17590391,17.889153 3.18050758,17.833909 L3.84717425,9.83390904 C3.93355627,8.79732479 4.80008849,8 5.84026576,8 Z M10.5,10 C10.2238576,10 10,10.2238576 10,10.5 L10,11.5 C10,11.7761424 10.2238576,12 10.5,12 L13.5,12 C13.7761424,12 14,11.7761424 14,11.5 L14,10.5 C14,10.2238576 13.7761424,10 13.5,10 L10.5,10 Z" fill="#000000" />
										<path d="M10,8 L8,8 L8,7 C8,5.34314575 9.34314575,4 11,4 L13,4 C14.6568542,4 16,5.34314575 16,7 L16,8 L14,8 L14,7 C14,6.44771525 13.5522847,6 13,6 L11,6 C10.4477153,6 10,6.44771525 10,7 L10,8 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
									</g>
								</svg>
								<!--end::Svg Icon-->
							</span>
						</div>
						<span class="filter-name">{{ $t("mobileClientsFilter.legalEntities") }}</span>
					</div>
					<div class="filter-selected" v-show="currentFilter === 'legalEntities'">
						<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check">
							<polyline points="20 6 9 17 4 12"></polyline>
						</svg>
					</div>
				</div>
			</div>
		</perfect-scrollbar>
	</div>
</template>

<script>
import MobileClientsFilterLayout from "@/assets/js/layout/extended/mobile-clients-filter.js";
import { CLOSE_ELEMENT } from "@/core/services/store/offcanvas.module.js";
import { enableBodyScroll } from "body-scroll-lock";

export default {
	name: "MobileServicesFilter",
	props: {
		/**
		 * Current filter
		 * @type {String}
		 */
		currentFilter: {
			type: String,
			required: true,
		},
	},
	mounted() {
		// Init Date Input Panel
		MobileClientsFilterLayout.init(this.$refs["mobile_clients_filter"]);
	},
	methods: {
		/**
		 * Handle outside click
		 * @return {void}
		 */
		handleOutsideClick(event) {
			if (event.target.classList.contains("offcanvas-overlay")) {
				this.close();
			}
		},

		/**
		 * Dispach CLOSE_ELEMENT action from offcanvas module
		 * @return {void}
		 */
		closeOffcanvas(elementId) {
			this.$store.dispatch(CLOSE_ELEMENT, elementId);
			let targetElement = document.querySelector("#mobile_clients_filter");
			enableBodyScroll(targetElement);
		},

		/**
		 * Close mobile clients filter element
		 * @return {void}
		 */
		close() {
			document.querySelector("#mobile_clients_filter_close").click();
		},

		/**
		 * Emit filter updated event
		 * @param {String} value
		 * @emits filter-updated
		 */
		updateFilter(value) {
			this.$emit("filter-updated", value);
			this.close();
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/sass/bb-styles/components/mobile-clients-filter.scss";
</style>
